import { helpers } from 'vuelidate/lib/validators';

export const positiveInteger = helpers.regex('positiveInteger', /^\d*$/);
